import axios from 'axios';

import {
  ENTITY_NAVIGATION_CLEAR,
  ENTITY_NAVIGATION_FETCH_START,
  ENTITY_NAVIGATION_FETCH_SUCCESS
} from '@constants/action-types';
import { DATA_TYPES } from '@components/config/constants';
import { BASE_URL } from '@constants/endpoints';
import { getDataTypeFilterParams } from '@components/filters/selectors';
import { getPortalOrdering, getPortalPaging } from '@components/portal/selectors';

let source = axios.CancelToken.source();

export const clearEntityNavigation = () => ({ type: ENTITY_NAVIGATION_CLEAR });

export const fetchEntityNavigation = (portalDataType, portalSubType, filterParams, orderParams, offset, limit) =>
  async dispatch => {
    const typeInfo = DATA_TYPES[portalDataType];
    if (!typeInfo) {
      return;
    }

    dispatch({ type: ENTITY_NAVIGATION_FETCH_START });

    source.cancel();
    source = axios.CancelToken.source();

    const params = {
      ...filterParams,
      ...orderParams,
      offset,
      limit,
      'data-table': 'True'
    };
    if (typeInfo.subType && portalSubType) {
      params[typeInfo.subType] = portalSubType;
    }

    try {
      const response = await axios.get(`${BASE_URL}${typeInfo.api}`, {
        cancelToken: source.token,
        params
      });
      dispatch({
        type: ENTITY_NAVIGATION_FETCH_SUCCESS,
        payload: {
          rows: response.data.results,
          count: response.data.count,
          offset,
          limit
        }
      });
    } catch (error) {
      if (!(error instanceof axios.Cancel)) {
        dispatch({ type: ENTITY_NAVIGATION_CLEAR });
      }
    }
  };

export const initEntityNavigation = (portalDataType, portalSubType) => (dispatch, getState) => {
  const state = getState();
  const typeInfo = DATA_TYPES[portalDataType];
  if (!typeInfo) {
    return;
  }

  // If portal rows are already loaded, use them directly (avoids extra API call)
  let existingRows = null;
  let existingCount = 0;
  if (typeInfo.subType && portalSubType) {
    existingRows = state.dataTables.rows[portalDataType]?.[portalSubType] || null;
    existingCount = state.dataTables.count[portalDataType]?.[portalSubType] || 0;
  } else {
    existingRows = state.dataTables.rows[portalDataType] || null;
    existingCount = state.dataTables.count[portalDataType] || 0;
  }

  const { offset, limit } = getPortalPaging(state, portalDataType, portalSubType);

  if (existingRows && existingRows.length > 0) {
    dispatch({
      type: ENTITY_NAVIGATION_FETCH_SUCCESS,
      payload: { rows: existingRows, count: existingCount, offset, limit }
    });
    return;
  }

  const filterParams = getDataTypeFilterParams(state, portalDataType, portalSubType);
  const orderParams = getPortalOrdering(state, portalDataType, portalSubType);
  dispatch(fetchEntityNavigation(portalDataType, portalSubType, filterParams, orderParams, offset, limit));
};

export const fetchEntityNavigationPage = (portalDataType, portalSubType, offset) =>
  (dispatch, getState) => {
    const state = getState();
    const { limit } = getPortalPaging(state, portalDataType, portalSubType);
    const filterParams = getDataTypeFilterParams(state, portalDataType, portalSubType);
    const orderParams = getPortalOrdering(state, portalDataType, portalSubType);
    dispatch(fetchEntityNavigation(portalDataType, portalSubType, filterParams, orderParams, offset, limit));
  };
